export const recentlyPlayedController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_recentlyPlayed',
        },
      },
    },
    on: {
      initial: 'updatingRP',
      states: {
        idle: {
          on: {
            RP_RERENDER: 'updatingRP',
            LAYOUT_CHANGE_END: {
              cond: 'isControllerEnabled_recentlyPlayed',
              target: 'checkRecentlyPlayedType',
            },
          },
        },
        checkRecentlyPlayedType: {
          always: [
            {
              target: 'fetchRecentlyPlayed',
              cond: 'shouldRefetchRecentlyPlayedForCategory',
            },
            {
              target: 'updatingRP',
            },
          ],
        },
        fetchRecentlyPlayed: {
          invoke: {
            src: 'fetchRecentlyPlayedGames',
            onDone: [
              {
                target: 'idle',
                actions: ['initAuthTokenRefresh', 'updateRetryStatus'],
                cond: 'isResponseInvalid_InternalAuthTokenVariant',
              },
              {
                target: 'updatingRP',
                actions: [
                  'updateRecentlyPlayedGames',
                  'getRecentlyPlayedJackpotV2',
                ],
              },
            ],
          },
        },
        updatingRP: {
          invoke: {
            src: 'fetchRecentlyPlayedContent',
            onDone: {
              target: 'updatedRp',
              actions: {
                type: 'batchLayoutOperations',
                data: '$event.data.updates',
                meta: {
                  selectors: ['$action.data'],
                },
              },
            },
          },
        },
        updatedRp: {
          after: {
            0: {
              target: 'idle',
              actions: {
                type: 'save',
                data: {
                  rpFirstLoad: false,
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
          cond: 'isControllerDisabled_recentlyPlayed',
        },
        RP_RERENDER: 'on',
      },
    },
  },
};
